import { render, staticRenderFns } from "./CtaGainAccess.vue?vue&type=template&id=8206781a&scoped=true&"
import script from "./CtaGainAccess.vue?vue&type=script&lang=js&"
export * from "./CtaGainAccess.vue?vue&type=script&lang=js&"
import style0 from "./CtaGainAccess.vue?vue&type=style&index=0&id=8206781a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8206781a",
  null
  
)

export default component.exports